import type { ReactNode } from 'react';
import { LayoutContext } from './layout-context';
import type { LandingLayout } from './types';

export const LayoutProvider = ({
  layout,
  children,
}: {
  layout: LandingLayout;
  children: ReactNode;
}) => <LayoutContext.Provider value={layout}>{children}</LayoutContext.Provider>;
